define('services/memberservices/paid-member.service',['app'], function (app) {
    return app.factory('paidMemberService', ['$q', 'OpenOther', 'auiDialog', '$sce', 'ngDialog', 'auiAgreementHelper', 'payService', '$state', '$filter', 'serviceresource',
        function ($q, OpenOther, auiDialog, $sce, ngDialog, auiAgreementHelper, payService, $state, $filter, serviceresource) {
            //查询可订购套餐列表
            function getCommodityList() {
                var defer = $q.defer();
                OpenOther.getCommodityList().then(function (resp) {
                    defer.resolve(resp);
                });
                return defer.promise;
            }

            //立即开通 订购套餐
            function subscribeCommodity() {
                var defer = $q.defer();
                var param = {
                    req: {}
                };
                OpenOther.subscribeCommodity(param).then(function (resp) {
                    defer.resolve(result);
                });
                return defer.promise;
            }

            //套餐详情
            function queryCommodityDetail(commodityId) {
                var defer = $q.defer();
                var param = {
                    req: {
                        commodityId: commodityId,
                        lang: 'zh_CN'
                    }
                };
                OpenOther.queryCommodityDetail(param).then(function (resp) {
                    defer.resolve(resp.value);
                });
                return defer.promise;
            }

            //查询用户的已订购套餐列表
            function getUserSubscriptionList() {
                var defer = $q.defer();
                OpenOther.getUserSubscriptionList().then(function (resp) {
                    defer.resolve(resp);
                });
                return defer.promise;
            }


            /**
             * 获取我的订单
             */
            function getUserOrderList(baseReq) {
                var defer = $q.defer();
                var param = {
                    req: baseReq
                };
                OpenOther.getUserOrderList(param).then(function (value) {
                    defer.resolve(value);
                }).catch(function (reason) {
                    defer.reject(ret);
                })
                return defer.promise;
            }

            //套餐订购
            function orderPlan(commodity4User, type) {
                var ngd = ngDialog.open({
                    template: 'pages/memberservices/orderPlan.html',
                    className: '',
                    closeByEscape: false,
                    closeByDocument: false,
                    overlay: false,
                    controller: ['$scope', function ($scope) {
                        //订购协议
                        var agreemenType = 1049;
                        var agreementVersions = '';
                        var tempUrl = '';

                        //自动续订标识
                        $scope.reNewCommodityChecked = true;
                        $scope.reNewCommodityCheckBox = function () {
                            $scope.reNewCommodityChecked = !$scope.reNewCommodityChecked;
                        }
                        //是否支持自动续订
                        $scope.renewType = commodity4User.renewType;
                        $scope.commodity4User = commodity4User;
                        //订购协议标识
                        $scope.agreementChecked = false;
                        $scope.agreementCheckBox = function () {
                            $scope.agreementChecked = !$scope.agreementChecked;
                        }

                        $scope.showAgreement = function () {
                            AUI.BaseJSUtil.redirectUrlByBlank(tempUrl);
                        };

                        //提交处理
                        $scope.submit = function () {
                            if ($scope.showSignAgreeSign && !$scope.agreementChecked) {
                                return;
                            }
                            ngd.close();
                            var defer = $q.defer();
                            //开通支付服务
                            payService.isPayable().then(function (isPay) {
                                if (isPay) {
                                    //未签署协议，先签协议
                                    if ($scope.showSignAgreeSign && $scope.agreementChecked) {
                                        auiAgreementHelper.signAgreement({
                                            agrType: agreemenType,
                                            version: agreementVersions,
                                            language: 'zh_CN'
                                        }).then(function (signAgreementResult) {
                                            if (signAgreementResult) {

                                                handlesubmit();

                                            } else {
                                                defer.reject()
                                                auiDialog.fail('订购协议签署失败，请联系客服');
                                            }
                                        });
                                    }
                                    //已经签署协议，直接订购
                                    else {
                                        handlesubmit();
                                    }
                                }
                                //未开通支付服务
                                else {
                                    ngDialog.open({
                                        template: 'pages/common/dialog.orderPlan.html',
                                        className: '',
                                        controller: ['$scope', function ($scope) {
                                            $scope.showpayservice = true;
                                            $scope.close = function () {
                                                ngDialog.close();
                                            };
                                            $scope.showPayServ = function () {
                                                ngDialog.close();
                                                $state.go('mysetting.payService.modInvoice', {}, {reload: true});
                                            };
                                        }]

                                    });
                                }
                            });

                            return defer.promise;
                        }

                        function handlesubmit() {
                            if (type == 1) {
                                subscribeCommodity().then(function (value) {
                                    auiDialog.success('套餐订购成功', function () {
                                        serviceresource.refresh().then(function (value1) {
                                            $state.go('memberservices.myCommodityList', {}, {reload: true});
                                        })

                                    });
                                }).catch(function (reason) {
                                    handlesubscribeCommodity(reason);
                                })
                            }
                            else {
                                renewCommodity().then(function (value) {
                                    auiDialog.success('套餐订购成功', function () {
                                        $state.go('memberservices.myCommodityList');
                                    });
                                }).catch(function (reason) {
                                    handlesubscribeCommodity(reason);
                                })
                            }
                        }

                        //处理订购返回值
                        function handlesubscribeCommodity(reason) {
                            if (reason.NSP_STATUS == "90150099" || reason.NSP_STATUS == "88820021") {
                                ngDialog.open({
                                    template: 'pages/common/dialog.orderPlan.html',
                                    className: '',
                                    controller: ['$scope', function ($scope) {
                                        $scope.showpayservice = false;
                                        $scope.close = function () {
                                            ngDialog.close();
                                        };
                                        $scope.showbalance = function () {
                                            ngDialog.close();
                                            $state.go('MyAccount.mainbalance.bill', {signParty: 0});
                                        };
                                    }]

                                });
                            }
                            else {
                                var msg = $filter("auiErrorCode")(reason.NSP_STATUS, reason.serviceName);
                                auiDialog.failSystemError(msg, function () {
                                });
                            }
                        }

                        //套餐订购
                        function subscribeCommodity() {
                            var defer = $q.defer();
                            var autoRenew = $scope.reNewCommodityChecked ? 1 : 2;
                            var param = {
                                req: {
                                    commodityID: commodity4User.commodityID ? commodity4User.commodityID : commodity4User.commodityId,
                                    autoRenew: $scope.renewType == 1 ? autoRenew : 2
                                }
                            };
                            OpenOther.subscribeCommodity(param).then(function (value) {
                                defer.resolve(value);
                            }).catch(function (reason) {
                                defer.reject(reason);
                            })
                            return defer.promise;
                        }

                        //续订
                        function renewCommodity() {
                            var defer = $q.defer();
                            var autoRenew = $scope.reNewCommodityChecked ? 1 : 2;
                            var param = {
                                req: {
                                    subscriptionID: commodity4User.subscriptionID,
                                    autoRenew: $scope.renewType == 1 ? autoRenew : 2
                                }
                            };
                            OpenOther.renewCommodity(param).then(function (resp) {
                                commodity4User.isRenew = 1;
                                defer.resolve(resp);
                            }).catch(function (reason) {
                                defer.reject(reason);
                            });
                            return defer.promise;
                        }

                        getIsSignAgreement(agreemenType).then(function (signedText) {
                            if (signedText) {
                                agreementVersions = signedText.latestVersion;
                                // 签署状态。1：已签署最新版本；2：已签署非最新版本；3：未签署；
                                if (signedText.signStatus == 1 || (signedText.signStatus == 2 && signedText.isForcedSign != 'true')) {
                                    $scope.showSignAgreeSign = false;
                                } else {
                                    $scope.showSignAgreeSign = true;
                                }
                                queryAgreeTemplate(agreemenType, signedText.latestVersion).then(function (respUrl) {
                                    tempUrl = respUrl;
                                });
                            }

                        });

                        $scope.close = function () {
                            ngd.close();
                        };
                    }]
                });
            }

            //更新续订标识
            function updateAutoRenew(subscriptionID, flag) {
                var defer = $q.defer();
                var param = {
                    req: {
                        subscriptionID: subscriptionID,
                        autoRenew: flag
                    }
                };
                OpenOther.updateAutoRenew(param).then(function (value) {
                    if (flag == 1) {
                        auiDialog.success("套餐已设置自动续订！");
                    }
                    else if (flag == 2) {
                        auiDialog.success("套餐已取消自动续订！");
                    }

                    defer.resolve(value);
                }).catch(function (reason) {
                    defer.reject();
                });
                return defer.promise;
            }

            //查询剩余权益
            function queryAsset(serviceDomain, subscriptionId) {
                var defer = $q.defer();
                var dataForamt = AUI.DateUtil.localDateFormat(new Date(), "GMT:yyyymmddHHMMss");
                var param = {
                    req: {
                        serverAppID: '60992',
                        messageID: "1" + dataForamt + '00003' + dataForamt.substring(7, 6),
                        serviceDomain: serviceDomain,
                        subscriptionId: subscriptionId
                    }
                };
                OpenOther.queryAsset(param).then(function (value) {
                    defer.resolve(value);
                }).catch(function (reason) {
                    defer.reject();
                })
                return defer.promise;
            }

            //判断是否签署过订购协议
            function getIsSignAgreement(agreemenType) {
                var defer = $q.defer();
                auiAgreementHelper.queryAgreements([agreemenType]).then(function (signInfo) {
                    if (signInfo && signInfo.signInfoList && signInfo.signInfoList.length > 0) {
                        var signedText = signInfo.signInfoList[0];
                        defer.resolve(signedText);
                    } else {
                        auiDialog.failSystemError();
                        defer.reject();
                    }
                });
                return defer.promise;
            }

            // 查询协议模板
            function queryAgreeTemplate(agrType, latestVersion) {
                var defer = $q.defer();
                auiAgreementHelper.agreementToTemplateInfo([{
                    agrType: agrType,
                    latestVersion: latestVersion
                }]).then(function (result) {
                    if (result && result.templateInfoList && result.templateInfoList.length > 0) {
                        var templateInfo = result.templateInfoList[0];
                        if (templateInfo) {
                            defer.resolve(templateInfo.url);
                        }
                        else {
                            defer.reject();
                        }
                    } else {
                        defer.reject();
                    }
                });
                return defer.promise;
            }

            return {
                getCommodityList: getCommodityList,
                subscribeCommodity: subscribeCommodity,
                queryCommodityDetail: queryCommodityDetail,
                getUserSubscriptionList: getUserSubscriptionList,
                updateAutoRenew: updateAutoRenew,//更新续订标识
                orderPlan: orderPlan,//订购
                getUserOrderList: getUserOrderList,//获取订单列表
                queryAsset: queryAsset,
                getIsSignAgreement: getIsSignAgreement
            }
        }]);
});


